<label
  class="input-label"
  [idOrDefault]="labelId"
  [attr.for]="inputId"
  [attr.aria-label]="label"
  [attr.data-e2e]="labelE2eId"
  *ngIf="label"
  >{{ label }}
  <span class="input-optional-text" *ngIf="!required">
    {{ optional || '(optional)' }}
  </span>
</label>

<div class="input-field">
  <input
    [idOrDefault]="inputId"
    class="input-value"
    [type]="type"
    [name]="inputName"
    [disabled]="disabled"
    [attr.data-e2e]="e2eId"
    [attr.placeholder]="placeholder"
    [attr.aria-label]="ariaLabel"
    [attr.aria-labelledby]="ariaLabelledby"
    [attr.aria-describedby]="ariaDescribedby"
    [attr.min]="min"
    (input)="onChange($event.target.value)"
    (focus)="onFocus($event)"
    (blur)="onBlur()"
    (change)="onUpdate($event.target.value)"
    value="{{ value }}"
    oninput="validity.valid||(value='');"
    [attr.autocomplete]="chromeAutocomplete"
    [attr.maxLength]="maxLength"
    #input
  />
</div>
<div idOrDefault class="input-helper-text" *ngIf="helperText">
  <span>{{ helperText }}</span>
</div>
<nibtravel-validation
  [validations]="validations"
  [control]="ngControl.control"
  [host]="formComponent"
  [trigger]="trigger$"
  [errorMessageOnFormGroup]="errorMessageOnFormGroup"
  [enableDistinctUntilChanged]="enableDistinctUntilChanged"
  (errorEmitter)="error.emit($event)"
  *ngIf="validations"
></nibtravel-validation>
